import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const scrollToTopAndNavigate = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                奶泡动漫
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              专注于高清动漫在线观看的平台，提供最新番剧、经典动漫、国漫、日漫海量资源，让每一位动漫爱好者享受极致追番体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/category/all'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  番剧分类
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/about'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/category/japanese"
                  onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/category/japanese'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  日漫
                </Link>
              </li>
              <li>
                <Link
                  to="/category/chinese"
                  onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/category/chinese'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  国漫
                </Link>
              </li>
              <li>
                <Link
                  to="/category/action"
                  onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/category/action'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  热血
                </Link>
              </li>
              <li>
                <Link
                  to="/category/fantasy"
                  onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/category/fantasy'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  奇幻
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-base"></i>
                <span>contact@naipaoanime.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-customer-service-2-line text-base"></i>
                <span>在线客服 7×24 小时</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2025 奶泡动漫 naipaoanime.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}